/**
 *
 */
export default class BaseUtils {
  /**
   *
   * @param {string} template
   * @param params
   * @return {string}
   */
  public static sprintf(template: string, ...params: any[]): string {
    let result: string = template;
    let re: RegExp;

    params.forEach(function (value: any) {
      switch (typeof value) {
        case 'string':
          re = new RegExp('%s', 'i');
          break;
        case 'number':
          re = new RegExp('%d', 'i');
          break;
      }
      result = result.replace(re, value);
    });
    return result;
  }

  /**
   * Читает куку
   *
   * @param {string} name
   * @return {string}
   */
  public static getCookie(name: string): string {
    let matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : '';
  }

  /**
   * Пишет куку
   *
   * Options:
   * {
   *  expires: string (UTCString) | number (кол-во секунд)
   *  path: string
   *  domain: string
   *  secure: boolean
   * }
   * @param {string} name
   * @param {string} value
   * @param options
   */
  public static setCookie(name: string, value: string | number, options?: any) {
    let expires, date, updatedCookie, propName, propValue;
    options = options || {};

    expires = options.expires;

    if (typeof expires == "number" && expires) {
      date = new Date();
      date.setTime(date.getTime() + expires * 1000);
      expires = options.expires = date;
    }
    if (expires && expires.toUTCString) {
      options.expires = expires.toUTCString();
    }

    value = encodeURIComponent(value.toString());

    updatedCookie = name + "=" + value;

    for (propName in options) {
      updatedCookie += "; " + propName;
      propValue = options[propName];
      if (propValue !== true) {
        updatedCookie += "=" + propValue;
      }
    }

    document.cookie = updatedCookie;
  }

  /**
   * Удаляет куку
   *
   * @param {string} name
   */
  public static deleteCookie(name: string): void {
    BaseUtils.setCookie(name, "", {
      expires: -1
    })
  }

  /**
   * Возвращает строку, лишённую всех символов, кроме бук(о)в
   *
   * @param {string} text
   * @return {string}
   */
  public static removeNonLetters(text: string): string {
    return text.replace(/[^0-9a-zа-яёїєґі]+/gmi, '');
  }
}
